import request from '../../utils/request'
const couponList = (data) => {
    return request({
        url: process.env.VUE_APP_API + 'shop/coupon/list',
        method: 'GET',
    })
}
const discount = (data) => {
    return request({
        url: process.env.VUE_APP_API + `particulars/coupon/${data}`,
        method: 'GET',
    })
}
const serveList = (data) => {
    return request({
        url: process.env.VUE_APP_APPOINTMENT + `coupon/list/${data}`,
        method: 'GET',
    })
}
const bind = (data) => {
  return request({
      url: process.env.VUE_APP_API + `coupon/bind`,
      method: 'POST',
      data
  })
}

export {
    couponList,
    discount,
    serveList,
    bind
}